import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AppSettingsService } from "../app-settings/app-settings.service";
import { BehaviorSubject, Observable, Subject } from "rxjs";

@Injectable({providedIn: "root"})
export class PrivilegeViewService {
  POR31302flag: boolean = false;
  private switchUrl = "";
  private privilegeSubject: Subject<any> = new BehaviorSubject<any>({});
  privilegeData: Observable<any> = this.privilegeSubject.asObservable();
  ELEVATED_PRIVILEGE_KEY = "tmc-current-domain";
  CURRENT_VIEW = "";
  
  constructor(public http: HttpClient,
    public appSettingsService: AppSettingsService) {
  }

  setDomainView(currentDomain) {
    if (currentDomain && currentDomain.includes("FedLLC")) {
      this.CURRENT_VIEW = "fedLLC";
      this.privilegeSubject.next({flag: this.POR31302flag, domainView: "fedLLC"});
    } else {
      this.CURRENT_VIEW = "cusReseller";
      this.privilegeSubject.next({flag: this.POR31302flag, domainView: "cusReseller"});
    }
  }

  getDomainView() {
    let currentView = this.CURRENT_VIEW; 
    if (currentView === undefined || currentView == null) {
      currentView = "cusReseller";
    }
    return currentView;
  }

  terminate() {
    return this.http.get("/terminate").toPromise();
  }

  async getSwitchUrl(domain) {
    const urlResponse = await this.http.get<any>("/api/settings/paladinRedirectUrl", {params: {domain}}).toPromise();
    this.switchUrl = urlResponse.redirectUrl;
  }

  async switchView(viewName) {
    await this.getSwitchUrl(viewName);
    this.terminate().then(() => {
      document.location.href = this.switchUrl;
    });
  }

  async init() {
    this.POR31302flag = (await this.appSettingsService.getFeaturePermission("POR312_TMC") ||
        await this.appSettingsService.getFeaturePermission("POR312"));
    this.privilegeSubject.next({flag: this.POR31302flag, domainView: this.getDomainView()});
  }
}
